/*
Copyright (C) 2009 - 2019 Broadleaf Commerce.

Licensed under the Broadleaf End User License Agreement (EULA),
Version 1.1 (the “Commercial License” located at
http://license.broadleafcommerce.org/commercial_license-1.1.txt).

Alternatively, the Commercial License may be replaced with a mutually
agreed upon license (the “Custom License”) between you and
Broadleaf Commerce. You may not use this file except in compliance
with the applicable license.
*/
import React from 'react';
import { find } from 'lodash';
import defaultImpersonateActions from 'app/view/components/actions';

// Formik is not set up for order views and the impersonate action requires one, causing an error.
// This sets up a mock formik object to eliminate the error message.
const formik = {};

const OrderImpersonateCustom = props => {
  const ImpersonateDefault = find(defaultImpersonateActions, {
    type: 'IMPERSONATE_CUSTOM'
  }).component;
  return <ImpersonateDefault formik={formik} {...props} />;
};

export default OrderImpersonateCustom;
